export default "__VITE_ASSET__WyO8_b_f__"